// extracted by mini-css-extract-plugin
export default {"button":"FontWeight_button__0UY11"};